import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import { UserProvider } from './context/UserContext';
import { initPlatform } from './services/telegram';
import { initInstall } from './services/install';
import { initPushSelfHeal } from './services/push';
import { initialSync } from './db/sync-queue';
import { initSnapshotPolling } from './services/snapshot';
import './i18n';
import '@fontsource-variable/manrope';
import './styles/global.css';
// Дизайны импортируются ПОСЛЕ global.css: их правила должны побеждать в каскаде
import './styles/designs/air.css';
import './styles/designs/glass.css';
import './styles/designs/aurora.css';
import './styles/designs/neo.css';
import './styles/designs/ukraine.css';
import './styles/designs/leaf.css';
import './styles/designs/vyshyvanka.css';

// Telegram-платформа — опциональное улучшение: SDK подгружается только внутри
// Mini App, в обычном браузере initPlatform — no-op (web-first, barter-024).
initPlatform().catch((e) => {
  console.error('[Barter] Failed to init platform:', e);
});

// Установка как приложения (barter-025): beforeinstallprompt может прийти до
// открытия Settings — слушатель вешаем сразу, кнопка прочитает стейт позже.
initInstall();

// Веб-пуш (barter-026): самолечение подписки на старте и возврате в приложение
// (ротация FCM, потерянные строки на сервере) — только если включал уведомления.
initPushSelfHeal();

// Данные живут локально: первая загрузка снапшота + отправка очереди записей,
// дальше — опрос версии meta.json (раз в 10 минут, при возврате сети/фокуса).
initialSync().catch(() => {});
initSnapshotPolling();

// Обновление сборки: autoUpdate-воркер активирует новый SW в фоне, а страница
// продолжает работать старым кодом. Вместо мгновенного reload — тост «Доступно
// обновление» (barter-025): слушатель controllerchange и периодическая проверка
// вешаются в App после монтирования (services/update.ts, initUpdateWatch).

const root = document.getElementById('root');
if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <UserProvider>
            <App />
          </UserProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>,
  );
}
